import { ArrowUpRight } from 'lucide-react';
import './styles/CommitteeStats.css';

interface Props {
  icon: any;
  title: string;
  value: string;
  subtitle: string;
  trend: string;
}

const StatCard = ({ icon: Icon, title, value, subtitle, trend }: Props) => {
  return (
    <div className="committee-stat-card">
      <div className="committee-stat-left ">
        <div className="committee-stat-icon">
          <Icon />
        </div>

        <div className="committee-stat-content">
          <div className="committee-stat-title">{title}</div>

          <div className="committee-stat-value">{value}</div>
        </div>
      </div>

      <div className="committee-stat-right">
        <div className="committee-stat-right-text">{subtitle}</div>

        <div className="committee-stat-trend">
          <ArrowUpRight size={12} />
          {trend}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
